var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComposersMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 15 14",
    strokeWidth: 0.7,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.85714,
    cy: 4.14285,
    r: 2.85714,
    stroke: "#141140",
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.85721 8.14285C3.01689 8.14285 0.714355 10.1896 0.714355 12.7143H11.0001C11.0001 10.1896 8.69753 8.14285 5.85721 8.14285Z",
    stroke: "#141140",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8574 5.61904C9.98489 6.57655 8.05098 8.98398 6.91285 11C8.56685 10.4667 11.3244 10.1746 11.8574 9.61904L10.5241 8.61904H12.5241C13.3241 7.81904 13.7463 6.06348 13.8574 5.28571L12.8574 5.61904Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85742 13.2857C6.52409 11.3968 8.71457 6.99999 12.8574 5.61904L13.8574 5.28571C13.7463 6.06348 13.3241 7.81904 12.5241 8.61904H10.5241L11.8574 9.61904C11.3244 10.1746 8.56685 10.4667 6.91285 11",
    stroke: "#141140",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComposersMenu);
export default __webpack_public_path__ + "static/media/composers_menu.a508304224976cc13672c1139446918a.svg";
export { ForwardRef as ReactComponent };